<template>
	<div class="wzry_content">
		<div class="wzry_form">
			<a class="logo" href="https://m.xubei.com/"><img src="/static/images/logo.png" /></a>
			<div class="text">
				虚贝网是专业的闲置游戏账号租赁平台，从2015年成立至今，已累计为平台商家创造约18253万收益，平均每商户月均收益约2700元。其首创的免密上号器登录技术及驱动级反挂技术大大降低了商户出租游戏帐号的风险，目前平台有上百款游戏数十万游戏账号在营出租。
			</div>
		</div>

		<div class="ftBtn">
			<a href="http://www.xubei.com/publishGoodsStepOne.htm" class="fb"><img src="/static/images/publisBtn.png" /></a>
		</div>

		<div class="copyright"><img src="/static/images/copy_right.png" /></div>
	</div>
</template>

<script>
import vuePickers from 'vue-pickers';
import { Toast } from 'mint-ui';
export default {
	name: 'home',
	components: { vuePickers, Toast },
	data: function () {
		return {};
	},
	mounted() {
		document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
			WeixinJSBridge.call('hideToolbar');
		});
	},
	methods: {}
};

// 百度统计代码
var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.wzry_content {
	width: 10rem;
	margin: 0 auto;
	height: px2rem(490rem);
	background: #251717 url(/static/images/publishBg.jpg) no-repeat;
	background-size: 100% auto;
	.wzry_form {
		padding: px2rem(20rem) px2rem(35rem) 0 px2rem(47rem);
		.logo {
			img {
				width: px2rem(278rem);
				height: px2rem(52rem);
			}
		}
		.text {
			color: #ffddb5;
			font-size: px2rem(34rem);
			line-height: px2rem(54rem);
			margin-top: px2rem(40rem);
			text-align: justify;
			opacity: 0.75;
		}
	}
	.ftBtn {
		margin-top: px2rem(95rem);
		text-align: center;
		a {
			display: block;
			img {
				width: px2rem(616rem);
				height: px2rem(105rem);
			}
		}
	}
	.copyright {
		text-align: center;
		margin-top: px2rem(417rem);
		img {
			width: px2rem(419rem);
			height: px2rem(31rem);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/home/publish.vue